/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_Active_Subscription_MessageInputs */

const en_common_no_active_subscription_message = /** @type {(inputs: Common_No_Active_Subscription_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You currently don't have an active subscription. Please subscribe to enjoy all features of our text-to-speech service.`)
};

const es_common_no_active_subscription_message = /** @type {(inputs: Common_No_Active_Subscription_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualmente no tienes una suscripción activa. Suscríbete para disfrutar todas las funciones de nuestro servicio de texto a voz.`)
};

/**
* | output |
* | --- |
* | "You currently don't have an active subscription. Please subscribe to enjoy all features of our text-to-speech service." |
*
* @param {Common_No_Active_Subscription_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_no_active_subscription_message = /** @type {((inputs?: Common_No_Active_Subscription_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_Active_Subscription_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_no_active_subscription_message(inputs)
	return en_common_no_active_subscription_message(inputs)
});